import WSService from "../shared/services/websocket-service";

export default WSService.getInstance();
